import React, { useState } from 'react';
import DeviceSelector from '../DeviceFrame/DeviceSelector';

const ThreePanelLayout = ({ leftPanel, middlePanel, rightPanel }) => {
  const [activeTab, setActiveTab] = useState('controls');

  return (
    <div className="flex flex-col lg:flex-row bg-white dark:bg-gray-900 text-gray-900 dark:text-white h-full transition-colors duration-200">
      {/* Mobile/Tablet: Tab Navigation */}
      <div className="lg:hidden flex border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
        <button
          onClick={() => setActiveTab('controls')}
          className={`flex-1 px-4 py-3 text-sm font-medium transition-colors ${
            activeTab === 'controls'
              ? 'bg-gradient-primary text-white'
              : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
        >
          Controls
        </button>
        <button
          onClick={() => setActiveTab('preview')}
          className={`flex-1 px-4 py-3 text-sm font-medium transition-colors ${
            activeTab === 'preview'
              ? 'bg-gradient-primary text-white'
              : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
        >
          Preview
        </button>
        <button
          onClick={() => setActiveTab('code')}
          className={`flex-1 px-4 py-3 text-sm font-medium transition-colors ${
            activeTab === 'code'
              ? 'bg-gradient-primary text-white'
              : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
        >
          Code
        </button>
      </div>

      {/* Mobile: Single Panel */}
      <div className="lg:hidden flex-1 min-h-0 overflow-hidden">
        {activeTab === 'controls' && (
          <div className="bg-gray-50 dark:bg-gray-800 h-full overflow-y-auto">{leftPanel}</div>
        )}
        {activeTab === 'preview' && (
          <div className="bg-white dark:bg-gray-900 h-full flex flex-col">
            <div className="flex-shrink-0 pt-4 px-2 sticky top-0 z-10 bg-white dark:bg-gray-900">
              <DeviceSelector />
            </div>
            <div className="flex-1 min-h-0 overflow-y-auto flex items-start justify-center pt-4">{middlePanel}</div>
          </div>
        )}
        {activeTab === 'code' && (
          <div className="bg-gray-50 dark:bg-gray-800 h-full overflow-y-auto">{rightPanel}</div>
        )}
      </div>

      {/* Tablet: 2-Panel Layout (Controls+Preview | Code) */}
      <div className="hidden md:flex lg:hidden h-full">
        <div className="flex-1 flex flex-col border-r border-gray-200 dark:border-gray-700 min-h-0">
          <div className="flex-shrink-0 flex border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
            <button
              onClick={() => setActiveTab('controls')}
              className={`flex-1 px-4 py-2 text-sm font-medium transition-colors ${
                activeTab === 'controls'
                  ? 'bg-gradient-primary text-white'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
              }`}
            >
              Controls
            </button>
            <button
              onClick={() => setActiveTab('preview')}
              className={`flex-1 px-4 py-2 text-sm font-medium transition-colors ${
                activeTab === 'preview'
                  ? 'bg-gradient-primary text-white'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
              }`}
            >
              Preview
            </button>
          </div>
          <div className="flex-1 min-h-0 overflow-hidden">
            {activeTab === 'controls' && (
              <div className="bg-gray-50 dark:bg-gray-800 h-full overflow-y-auto">{leftPanel}</div>
            )}
            {activeTab === 'preview' && (
              <div className="bg-white dark:bg-gray-900 h-full flex flex-col">
                <div className="flex-shrink-0 pt-4 px-2 sticky top-0 z-10 bg-white dark:bg-gray-900">
                  <DeviceSelector />
                </div>
                <div className="flex-1 min-h-0 overflow-y-auto flex items-start justify-center pt-4">{middlePanel}</div>
              </div>
            )}
          </div>
        </div>
        <div className="w-96 bg-gray-50 dark:bg-gray-800 overflow-y-auto">{rightPanel}</div>
      </div>

      {/* Desktop: 3-Panel Layout - All panels sticky and independently scrollable */}
      <div className="hidden lg:flex h-full w-full min-h-0">
        {/* Left Panel - Controls */}
        <div className="w-80 bg-gray-50 dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 flex-shrink-0 h-full overflow-y-auto sticky top-0">
          {leftPanel}
        </div>
        
        {/* Middle Panel - Preview */}
        <div className="w-[600px] bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-700 flex flex-col flex-shrink-0 h-full sticky top-0">
          <div className="flex-shrink-0 pt-4 px-2 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
            <DeviceSelector />
          </div>
          <div className="flex-1 min-h-0 overflow-y-auto flex items-center justify-center pt-4 pb-4">
            {middlePanel}
          </div>
        </div>
        
        {/* Right Panel - Generated Code */}
        <div className="flex-1 bg-gray-50 dark:bg-gray-800 flex-shrink-0 h-full overflow-y-auto sticky top-0">
          {rightPanel}
        </div>
      </div>
    </div>
  );
};

export default ThreePanelLayout;

